import { ButtonGroup, Modal } from 'slab'

import { useCardPayment } from './CardPaymentProvider'
import StripePayment from './stripe/StripePayment'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export default function CardPaymentModal ({ open, onOpenChange }: Props) {
  const {
    stripePublishableKey,
    onPaymentMethodSelected,
    createPaymentMethod,
    isCreatingPaymentMethod,
  } = useCardPayment()

  const onClickSubmitPayment = async () => {
    const paymentMethod = await createPaymentMethod?.()
    if (paymentMethod) {
      onPaymentMethodSelected(paymentMethod)

      return true
    }

    return false
  }

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <Modal.Body>
        <StripePayment stripePublishableKey={stripePublishableKey} />
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup size='large'>
          <Modal.Button variant='secondary'>
            Cancel
          </Modal.Button>
          <Modal.Button variant='primary' onClick={onClickSubmitPayment} disabled={isCreatingPaymentMethod}>
            {isCreatingPaymentMethod ? 'Processing...' : 'Add card'}
          </Modal.Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  )
}
